import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from './slices';

export const store = configureStore({
    reducer: rootReducer,
    devTools: window.__REDUX_DEVTOOLS_EXTENSION__ ? true : false,
});
